.disabled {
	pointer-events: none;
	opacity: 0.5;
}

.dataEntryLabel {
	color: var(--text-color);
	font-size: var(--font-size--sm);
	font-weight: var(--font-weight--medium);
}

.dataEntrySubLabel {
	color: var(--text-color--subtler);
	font-size: var(--font-size--2xs);
	font-weight: var(--font-weight--regular);
}
